import { apiURL, axiosInstance } from 'constants/config';
import {
  loadAdditionalPapersRequested,
  loadAdditionalpapersSuccess,
  loadAdditionalPapersFail,
  storeAdditionalPaperRequested,
  storeAdditionalPaperSuccess,
  storeAdditionalPaperFail,
  updateAdditionalPaperRequested,
  updateAdditionalPaperSuccess,
  updateAdditionalPaperFail,
  archiveAdditionalPaperRequested,
  archiveAdditionalPaperSuccess,
  archiveAdditionalPaperFail,
  deleteAdditionalPaperRequested,
  deleteAdditionalPaperSuccess,
  deleteAdditionalPaperFail,
} from './additionalpapersSlice';

import { put, call, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { loadCustomerEffect } from 'store/customers/sagas';
import { loadCustomerActivityLogsEffect } from 'store/reports/sagas';
import moment from 'moment';
import { loadBillInfoEffect } from 'store/payments/sagas';

export function* loadAdditionalPapersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/papers/additional-papers/${
        action.payload?.filters?.reference
      }?SearchValue=${
        action?.payload?.filters?.query ?? ''
      }&PaginationOption.Page=${
        action.payload.page
      }&PaginationOption.PageSize=${action.payload.perPage}`
    );

    yield put(loadAdditionalpapersSuccess(data));
  } catch (error: any) {
    yield put(loadAdditionalPapersFail(error.message));
  }
}

export function* storeAdditionalPaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const today = moment.utc().format('YYYY-MM-DD');
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/customers/papers/additional`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeAdditionalPaperSuccess(data));

      yield call(loadBillInfoEffect, {
        payload: action?.payload?.customerReference,
        type: '',
      });
      yield call(loadAdditionalPapersEffect, {
        payload: {
          filters: { reference: action?.payload?.customerReference, query: '' },
          page: 1,
          perPage: 10,
        },
        type: 'loadPapersAfterAdd',
      });
      yield call(loadCustomerActivityLogsEffect, {
        payload: {
          ids: [data?.result],
          startDate: null,
          endDate: today,
          isDetailBill: false,
        },
        type: '',
      });
      toast.success('Additional paper created successfully');
    } else {
      toast.error('Failed to create additional paper', data?.errors);
    }
  } catch (error: any) {
    yield put(storeAdditionalPaperFail(error.message));
  }
}

export function* updateAdditionalPaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/papers/${action.payload?.id}`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updateAdditionalPaperSuccess(data));
      yield call(loadAdditionalPapersEffect, {
        payload: {
          filters: { reference: action?.payload?.customerReference, query: '' },
          page: 1,
          perPage: 10,
        },
        type: 'loadPapersAfterAdd',
      });

      toast.success('Additional paper updated successfully');
    } else {
      toast.error(data?.errors || 'Failed to update paper');
    }
  } catch (error: any) {
    yield put(updateAdditionalPaperFail(error.message));
  }
}

export function* archiveadditionalPaperEffect(action: {
  type: string;
  payload: any;
}) {
  try {
    const { item } = action.payload;
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/papers/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(archiveAdditionalPaperSuccess(data));
      if (item.isActive) {
        toast.success('Paper archived successfully');
      } else {
        toast.success('Paper unarchived successfully');
      }
      yield call(loadAdditionalPapersEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: '',
      });
    }
  } catch (error: any) {
    yield put(archiveAdditionalPaperFail(error.message));
  }
}

export function* deleteAdditionalPaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/customers/papers/additional/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(deleteAdditionalPaperSuccess(data));
      toast.success('Additional paper deleted successfully');
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(deleteAdditionalPaperFail(error.message));
  }
}

export function* additionalPapersSaga(): Generator<any, void, any> {
  yield takeEvery(loadAdditionalPapersRequested, loadAdditionalPapersEffect);
  yield takeEvery(storeAdditionalPaperRequested, storeAdditionalPaperEffect);
  yield takeEvery(updateAdditionalPaperRequested, updateAdditionalPaperEffect);
  yield takeEvery(
    archiveAdditionalPaperRequested,
    archiveadditionalPaperEffect
  );
  yield takeEvery(deleteAdditionalPaperRequested, deleteAdditionalPaperEffect);
}
